export const areStitchingAttributesFulfilled = state => state.stitchingAttributes.isFulfilled
export const getStitchingAttributesMap = state => state.stitchingAttributes.data
export const getExistingStitchingAttributesIds = state => {
  return Object.keys(state.stitchingAttributes.data)
}
export const getStitchingAttributeById = (state, id) => state.stitchingAttributes.data[id]
